import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    viewBox: "0 0 24 24",
    color: "#193446",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<g fill="currentColor"> <path fill-rule="evenodd" clip-rule="evenodd" d="M12 20.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17m0 1.5c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"/> <path d="M13 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-.2-9h-1.6a.2.2 0 0 0-.2.2V13s0 1 1 1 1-1 1-1V7.2a.2.2 0 0 0-.2-.2"/> </g>' }
  })
);